export const FAPI_URL = 'https://api.funid.com';
export const FAPI_URL_DEV = 'https://api-dev.funid.com';
export const CAPI_URL = 'https://content.funid.com/api';
export const CAPI_URL_DEV = 'https://cms-dev.funid.com/api';
export const CDN_URL = 'https://content.funid.com';
export const CDN_URL_DEV = 'https://cms-dev.funid.com';
//# sourceMappingURL=funid-env.js.map